const normalizeWalletName = (name) => name?.toLowerCase().replace(/\W/g, '') ?? 'undefined-wallet';

export { normalizeWalletName };
